import React from "react"
import { Link } from "react-router-dom"

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false, error: null }
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error }
  }

  componentDidCatch(error, errorInfo) {
    console.error("ErrorBoundary caught an error:", error, errorInfo)
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex min-h-screen flex-col items-center justify-center bg-richblack-900 px-4 text-center">
          <h1 className="text-4xl font-bold text-richblack-5 mb-4">
            Something went wrong
          </h1>
          <p className="text-lg text-richblack-200 mb-8 max-w-md">
            An unexpected error occurred. Please try again or go back to the
            home page.
          </p>
          <Link
            to="/"
            onClick={() => this.setState({ hasError: false, error: null })}
            className="rounded-md bg-caribbeangreen-200 px-6 py-3 text-lg font-semibold text-richblack-900 hover:bg-caribbeangreen-300 transition-all duration-200"
          >
            Go Home
          </Link>
        </div>
      )
    }

    return this.props.children
  }
}

export default ErrorBoundary
